<template>
    <div class="form__group" :class="{'disabled':  disabled}">
        <input v-model="inputValue" class="form__field" :style="{cursor: readonly ? 'pointer' : ''}"
               :class="{'form__field_active': inputValue.length > 0, 'error': error}"
               type="text"
               :name="id"
               :id="id"
               :readonly="readonly"
               @input="changeInput($event)"
               @blur="$emit('blur')"
               @focus="$emit('focus')" :disabled="disabled" @click.stop="getToggleSelect"
               required>
        <label :for="id" class="form__label">{{ name }}</label>
        <div class="v-spoiler-icon" :class="{'open': isActive}" v-if="selector" @click.stop="getToggleSelect"/>
        <p class="form__field-error" v-if="errorText">{{ errorText }}</p>
        <div v-if="filteredOptions.length > 0 && isActive" class="v-select__options">
            <div class="v-select__options-wrap">
                <p
                    class="v-select__option"
                    v-for="(option, key) in filteredOptions"
                    :key="key"
                    @click="selectedOption(option, key)"
                >
                    {{ option.name }}
                </p>
            </div>
            <!--            :class="{selected: (key==currentOption)}"-->
        </div>
    </div>
</template>

<script>
export default {
    name: "inputSelectField",
    props: {
        id: {
            type: String,
            default: '',
        },
        selector: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        error:{
            type: Boolean,
            default: false,
            },
        errorText: {
            type: String,
            default: null,
        },
        value: {
            default: '',
        },
        options: {
            type: Array,
            default(){
                return []
            }
        },
        startOption: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        greedySearch: {
            type: Boolean,
            default: true,
        },
        //имя поля отвечающее за значение
        valueFieldName: {
            type: String,
            default: "value",
        },
        //Надпись если ничего не выбрано
        title: {
            type: String,
            default: ""
        },
    },
    model: {
        prop: "value",
        event: "input"
    },
    data(){
        return {
            inputValue: '',
            currentOption: null,
            sortedOptions: [],
            filteredOptions: [],
            lastValue: null,
            defaultOption: null,
            isSame: false, //флаг срабатывает при совпадении значения инпута и опции
        }
    },
    mounted(){
        document.addEventListener('click', this.hideSelect.bind(this), false);
        this.setDefaultOption()
        this.sort()
    },
    beforeDestroy() {
        document.removeEventListener('click', this.hideSelect)
    },
    computed: {
        isActive() {
            return this.$store.state.Dropdowns.activeDropdown === this.id;
        }
    },
    methods: {
        setDefaultOption() {
            this.defaultOption = this.startOption
            if (this.defaultOption) {
                this.selectedOption(this.defaultOption, 0)
            } else {
                this.inputValue = ''
            }
            if(this.title){
                this.inputValue = this.title
            }
        },
        hideSelect() {
            if (this.isActive) {
                this.$store.dispatch('Dropdowns/closeAllDropdowns')
            }
        },
        getToggleSelect() {
            if (this.disabled) return
            
            if (this.isActive) {
                this.$store.dispatch('Dropdowns/closeAllDropdowns')
            } else {
                this.filteredOptions = this.sortedOptions
                if (!this.disabled) this.$store.dispatch('Dropdowns/setActiveDropdown', this.id)
            }
        },
        selectedOption(option, key) {
            this.inputValue = option.name
            this.currentOption = key
            this.isSame = true
            if (this.lastValue !== option[this.valueFieldName]) {
                this.lastValue = option[this.valueFieldName]
                setTimeout(() => {
                    this.$emit('input', option[this.valueFieldName])
                    this.$emit('change', option)
                }, 1000)
            }
        },
        sort() {
            if (this.isSortOption) {
                let res = Object.assign([], this.options)
                let emptyElement = res.find(item => {
                    return item[this.valueFieldName] == null
                })
                let index = res.indexOf(emptyElement)
                if (index !== -1) res.splice(index, 1)
                if (res) {
                    res.sort((prev, next) => {
                        if (prev.name < next.name) return -1;
                        if (prev.name < next.name) return 1;
                    });
                }
                if (index !== -1) res.unshift(emptyElement)
                this.sortedOptions = res
            } else {
                this.sortedOptions = this.options
            }
        },
        getFilterOptions() {
            if (this.ignoreFilter === true) {
                this.filteredOptions = this.sortedOptions
            } else {
                let filteredOptions = []
                let value = this.inputValue ? this.inputValue : ''
                this.sortedOptions.forEach(item => {
                    if (typeof item.name === "string") {
                        if (value !== this.title && this.greedySearch) {
                            if (item.name.toLowerCase().indexOf(value.toLowerCase()) == 0) {
                                filteredOptions.push(item)
                            }
                        } else {
                            if (item.name.toLowerCase().includes(value.toLowerCase())) {
                                filteredOptions.push(item)
                            }
                        }
                        if (item.name.toLowerCase() === value.toLowerCase()) {
                            this.inputValue = item.name
                            this.isSame = true
                            if (this.lastValue !== item[this.valueFieldName]) {
                                this.lastValue = item[this.valueFieldName]
                            }
                        }
                    }
                })
                this.filteredOptions = filteredOptions
            }
            if (!this.sortedOptions.length && this.defaultOption) {
                this.filteredOptions.push(this.defaultOption)
            } else if (this.sortedOptions.length && this.defaultOption) {
                let obj = this.sortedOptions.find(item => item[this.valueFieldName] === this.defaultOption[this.valueFieldName])
                let idx = this.sortedOptions.indexOf(obj)
                if (idx !== -1) {
                    this.selectedOption(this.sortedOptions[idx], idx)
                }
                this.defaultOption = null
            }
            if (this.filteredOptions.length > 0 && !this.isSame) {
                this.showList = true
            } else {
                this.showList = false
            }
        },
        changeInput() {
            this.getFilterOptions()
            this.isSame = false
            this.$emit('input', this.inputValue);
        },
    },
    watch: {
        options(value) {
            if (!this.defaultOption) {
                if (this.lastValue !== -1) {
                    this.lastValue = -1
                }
            }
            this.sort()
            this.getFilterOptions()
        },
        title(value) {
            this.inputValue = value
            this.getFilterOptions()
        },
        startOption(value){
            this.setDefaultOption()
        },
    }
}
</script>

<style lang="scss" scoped>

.form__group{
    position: relative;
}
.v-select__options{
    position: absolute;
    top: 55px;
    border: 1px solid #DBE0E5;
    border-radius: 4px;
    max-height: 202px;
    width: 100%;
    background: white;
    z-index: 1;
    overflow: auto;
    &::-webkit-scrollbar {
        width: 2px;
    }

    &::-webkit-scrollbar-track {
        background-color: grey;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-button {
    }

    &::-webkit-scrollbar-corner {
    }
}
.v-select__option{
    background-color: white;
    padding: 0 8px;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #DBE0E5;
    cursor: pointer;
    overflow: hidden;
}
.v-select__option:hover{
    background-color: #F6F8FA;
}
.form__field{
    border-radius: 6px;
    color: #888ea8;
    letter-spacing: 1px;
    padding: 0px 10px 0px 10px;
    height: 36px;
    width: 270px;
}
.form__field.error{
    border: 2px solid red;
    color: red;
}
.form__group.disabled{
    & .form__field{
        border: 1px solid #E9EAEC;
        color: #B5B8BC;
    }
    & .form__label{
        color: #B5B8BC;
    }
    & .v-spoiler-icon{
        background: #E9EAEC;
    }
}
</style>
